import React, { useEffect, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';

import { apiList } from '../api/callAPI';
import { baseUrl } from '../api/api';

import logo from '../assets/images/HAiReport_color_vertical.svg';
import bg from '../assets/images/bg_wave.png';

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import FormHelperText from '@mui/material/FormHelperText';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import useUser from '../hook/useUser';
import * as basicConstants from '../constants/basic';
import * as urlConstants from '../constants/url';
import * as alertConstants from '../constants/alertMsg';

import { FullImage } from '../components/CustomComp';

import Copyright from '../components/copyright/Copyright';
import GoogleSigninButton from '../components/buttons/GoogleSigninButton';

import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import { BoxFlexColumnCenterCenter } from '../components/customComponent/box';
import theme from '../theme';

const boxgreyLine = {
  borderBottom: `1px solid ${theme.palette.grey.w300}`,
  flex: '1 0 auto',
  height: '0.5em',
}

const textsmGrey = {
  flex: '0.2 0 auto',
  fontSize: '0.75rem',
  textAlign: 'center',
  color: theme.palette.grey.w500,
  padding: '6px 0 0 0',
}

const Login = (props) => {
  const intl = useIntl();
  document.title = `${intl.formatMessage({ id: "common.login.login" })}${basicConstants.TITLE_PRODUCT_NAME}`;
  const theme = useTheme();
  const history = useHistory();
  const location = useLocation();
  const { userData, setUserData, authStatusMsg, setAuthStatusMsg } = useUser();
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showLogin, setShowLogin] = useState(true);

  useEffect(() => {
    if (userData && sessionStorage.getItem(basicConstants.SESSION_CREATE_TIME)) {
      history.push(urlConstants.PAGE_MEDIA_MENU);
    }
  }, [userData])

  const handleLoginStatus = (status) => {
    setIsLoading(status);
  }

  const handleLogin = () => {
    apiList.apiUserLogin({
      "username": userName,
      "password": password
    })
      .then(res => {
        setIsLoading(false);
        if (res?.status === 200) {
          sessionStorage.setItem(basicConstants.SESSION_CREATE_TIME, Date.now());
          setUserData(res.data.result);
          history.push(urlConstants.PAGE_MEDIA_MENU);
        }
      })
  }

  console.log(process.env.REACT_APP_VERSION);

  return (
    <>
      {
        !userData && showLogin &&
        <Box
          sx={{
            minHeight: '100vh',
            background: `url(${bg}) no-repeat center bottom`,
            borderTop: `8px solid ${theme.palette.system.w500}`,
            boxSizing: 'border-box',
          }}
        >
          <Box
            sx={{
              margin: '8% auto 0',
              borderRadius: '8px',
              textAlign: 'center'
            }}
          >
            <Box sx={{ width: '200px', margin: '0 auto 40px' }}>
              <FullImage src={logo} alt="HAi Report" />
            </Box>

            <BoxFlexColumnCenterCenter>
              {
                authStatusMsg &&
                <FormHelperText
                  error
                  sx={{
                    marginTop: 2,
                    marginBottom: 2,
                    textAlign: 'center',
                    fontSize: '1rem'
                  }}
                >
                  <FormattedMessage id={authStatusMsg} />
                </FormHelperText>
              }
              {
                baseUrl.loginType === 'systemAndGoogle' &&
                <>
                  <Box
                    sx={{
                      width: '280px',
                      margin: '8px auto 8px',
                      textAlign: 'center'
                    }}
                  >
                    <Box mb={2}>
                      <TextField
                        fullWidth
                        placeholder={intl.formatMessage({ id: "common.login.account" })}
                        onChange={(e) => setUserName(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            handleLogin();
                          }
                        }}
                        sx={{
                          '& .MuiInputBase-input': {
                            padding: '8px 4px',
                          },
                        }}
                      />
                    </Box>

                    <Box mb={2}>
                      <TextField
                        fullWidth
                        placeholder={intl.formatMessage({ id: "common.login.password" })}
                        type='password'
                        onChange={(e) => setPassword(e.target.value)}
                        sx={{
                          '& .MuiInputBase-input': {
                            padding: '8px 4px',
                          },
                        }}
                      />
                    </Box>

                    <Button
                      fullWidth
                      variant='fill-create'
                      type='submit'
                      onClick={handleLogin}
                      sx={{
                        color: '#fff',
                        backgroundColor: theme.palette.system.w500,
                        '&:hover': {
                          backgroundColor: theme.palette.system.w700,
                        }
                      }}
                    >
                      <FormattedMessage id="common.login.login" />
                    </Button>
                  </Box>

                  <Stack variant="center-center" width='280px' margin='16px auto 0'>
                    <Box style={boxgreyLine}></Box>
                    <Typography style={textsmGrey}>OR</Typography>
                    <Box style={boxgreyLine}></Box>
                  </Stack>
                </>
              }

              <Box mt={4}>
                <GoogleSigninButton handleLoginStatus={handleLoginStatus} />
              </Box>
            </BoxFlexColumnCenterCenter>

          </Box>

          <Copyright style={{ color: '#fff', textAlign: 'center' }} />
        </Box>
      }
      <Backdrop
        sx={{ color: '#fff', zIndex: 500 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default Login;